<template>
  <div class="service">
    <div class="cards">
      <div class="title">
        <div class="bottom">我们提供的专业化服务</div>
      </div>
      <div class="cardList" >
        <div class="card" v-for="item in article_list" :key="item.id" @click="gotoDetail(item.id)">
          <div class="img">
            <img :src="item.thumb" alt="" />
          </div>
          <div class="cardTitle">{{ item.title }}</div>
          <div class="content">
            {{ item.desc }}
          </div>
          <div class="arrow">
            <img src="../assets/images/solution/arrowRight.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
      cardInfo: [
        {
          id: 1,
          imgSrc: require("../assets/images/solution/智慧维保.png"),
          title: "网络维保",
          content:
              "网络维护就是监督、组织和控制网络通信服务，目的是保证计算机网络的持续正常运行，并在计算机网络运行出现异常时能及时响应和排除故障。",
        },
        {
          id: 2,
          imgSrc: require("../assets/images/solution/cps 移动推送.png"),
          title: "协作型专业服务CPS",
          content:
              "CPS服务是一项思科与总代协作，为客户的软硬件产品（此处特指路由交换方面）提供专业的体检、改造、优化的服务",
        },
        {
          id: 3,
          imgSrc: require("../assets/images/solution/数据运维.png"),
          title: "数据中心运维",
          content:
              "实现数据中心日常运维工作的电子化、规范化、流程化、自动化，使数据中心管理者能够追踪运维工作的处理进展，考核员工的工作绩效，统筹全局。",
        },
        {
          id: 4,
          imgSrc: require("../assets/images/solution/PPDIOO高级服务.png"),
          title: "PPDIOO高级服务",
          content:
              "PPDIOO是Cisco生命周期法，它持续发展的生命周期定义了网络所需的各项服务。",
        },
      ],
      cardInfoActive: [],
      activeBtn: 1,

        article_list:[]
    };
  },
    created() {
        this.getarticlelist();
    },
  mounted() {
    this.cardInfoActive = this.cardInfo.slice(0);
  },
  methods: {
      getarticlelist() {
          let self = this;
          var url = "index/article_list?cate_id=7";
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              self.article_list = res.data.data.list;
          })
      },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    gotoDetail(val) {
      this.$router.push(`/service/detail/${val}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.service {
  width: 192rem;

  .cards {
    background-color: #eef3f7;
    height: 100rem;
    overflow: hidden;

    .title {
      width: 100%;
      height: 10rem;
      padding: 5rem;
      text-align: center;

      .top {
        margin: 0 auto;
        font-size: 1.6rem;
        color: #b3b4b9;
        padding-left: 5rem;
        height: 3rem;
        line-height: 3rem;
        position: relative;

        span {
          position: absolute;
          display: inline-block;
          width: 1.5rem;
          height: 0;
          left: 46%;
          top: 1.4rem;
          border-top: 0.3rem solid #19d6ae;
        }
      }

      .bottom {
        margin: 0 auto;
        padding: 2rem 0;
        font-size: 4rem;
        color: #404447;
      }
    }

    .cardList {
      width: 160rem;

      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .card {
        width: 38rem;
        height: 64rem;
        background-color: #fff;
        border-radius: 1rem;
        text-align: center;
        transition: all 1s linear;
        cursor: pointer;

        .img {
          width: 14rem;
          height: 14rem;
          padding: 5rem 0 0 11.5rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .cardTitle {
          font-size: 2.4rem;
          color: black;
          font-weight: 400;
          padding: 3rem 0;
        }

        .content {
          font-size: 1.6rem;
          color: #9a99a0;
          padding: 0 4rem 2rem 4rem;
          line-height: 2;
          height: 22rem;
          transition: all 1s linear;
        }

        .arrow {
          width: 6rem;
          height: 7rem;
          cursor: pointer;
          padding: 0 0 0 16rem;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .card:hover {
        transition: 1s;

        .content {
          transition: 1s;
          color: black;
        }
      }
    }

    .banner {
      position: relative;
      margin-top: -9rem;

      img {
        width: 100%;
      }

      .text {
        position: absolute;
        left: 11rem;
        top: 35rem;
        font-size: 5rem;
        color: #fff;
        width: 75rem;
        text-align: left;
        font-weight: 700;
      }

      .text2 {
        position: absolute;
        right: 55rem;
        top: 29.5rem;
        color: rgba(0, 0, 0, 0.7);
        font-size: 3.6rem;
        width: 22rem;
      }

      .bannerBtn {
        position: absolute;
        left: 11rem;
        top: 52rem;
        width: 32rem;
        height: 9rem;
        cursor: pointer;
      }
    }
  }

  .introductions {
    width: 100%;
    height: 51rem;
    z-index: 99;
    background-color: #eef3f7;
    padding: 5rem 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .left {
      text-align: left;
      width: 32rem;
      padding-left: 16rem;
      padding-right: 8rem;

      .introTitle {
        color: #838389;
        position: relative;
        padding-left: 2rem;
        font-size: 2rem;

        span {
          position: absolute;
          left: 0.2rem;
          top: 1rem;
          width: 1.2rem;
          height: 0;
          border-top: 0.3rem solid #2cd5b8;
        }
      }

      .introContent {
        color: black;
        font-size: 4.6rem;
        font-weight: 500;
        line-height: 2;
        margin-top: 3rem;
      }

      .introArrow {
        margin-top: 8rem;

        img {
          width: 5rem;
          height: 5rem;
          cursor: pointer;
        }
      }
    }

    .right {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      .introCard {
        width: 62rem;
        height: 49rem;
        padding: 8rem;
        box-sizing: border-box;
        margin-right: 6rem;
        border-radius: 1rem;
        background-color: #fff;
        cursor: pointer;
        transition: all 1s linear;

        .cardTop {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;

          .imgLeft {
            width: 8rem;
            height: 8rem;
            overflow: hidden;
            border-radius: 4rem;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .name {
            margin-left: 3rem;
            width: 24rem;

            .nameTop {
              font-size: 2.4rem;
              color: black;
              text-align: left;
            }

            .nameBottom {
              font-size: 2rem;
              color: #4f9df7;
              text-align: left;
            }
          }

          .imgRight {
            width: 6rem;
            height: 6rem;
            margin-left: 5rem;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .cardBottom {
          padding-top: 2rem;
          font-size: 2rem;
          color: #a4a3a8;
          line-height: 1.8;
          text-align: left;
          transition: all 1s linear;
        }
      }

      .introCard:hover {
        transition: 1s;
        background-color: rgba(255, 255, 255, 0.8);

        .cardBottom {
          transition: 1s;
          color: #404447;
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .service{
    .cards{
      height: auto;
      .title{
          height: 20rem;
      .bottom{
        font-size: 7rem;
      }
    }
    .cardList{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
      .card{
          width: 45%;
          height: auto;
          overflow: hidden;
          margin-bottom: 6rem;

        .img{
            width: 30%;
            height: auto;
            margin: 0 auto;
            padding: 5rem 0;
          img{
              //display: none;
          }
        }
        .arrow{
          display: none;
        }
        .cardTitle{ font-size: 8rem;}
        .content{ text-align: left;padding-bottom: 30rem;}
      }
    }
    }

  }
}
</style>
